import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const RetryRotatedIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 20)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
    >
      <path d="M4 11C4 .50001 18 1 18 9.9515 18 13 16.1 17 10.5 17" />
      <path d="m7.5 10-3.86364 2L1.5 8" />
    </SVG>
  );
};
